import { FileIcon, JpgIcon, Mp4Icon, PngIcon, WebMIcon, YmlIcon, ZipIcon } from "../icon_templates/icons";

export const AddFileIcon = (fileName, classnames) =>{
    switch(true){
        case fileName.endsWith(".jpg"):
            return <JpgIcon IconStyleClass={classnames}/>
            
        case fileName.endsWith(".png"):
            return <PngIcon IconStyleClass={classnames}/>
            
        case fileName.endsWith(".jpeg"):
            return <JpgIcon IconStyleClass={classnames}/>
            
        case fileName.endsWith(".yml"):
            return <YmlIcon IconStyleClass={classnames}/>
            
        case fileName.endsWith(".mp4"):
            return <Mp4Icon IconStyleClass={classnames}/>
        
        case fileName.endsWith(".webm"):
            return <WebMIcon IconStyleClass={classnames}/>

        case fileName.endsWith(".zip"):
            return <ZipIcon IconStyleClass={classnames}/>
        default:
            return <FileIcon IconStyleClass={classnames}/>
            
    }

    
}